/* import __COLOCATED_TEMPLATE__ from './heading.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();